var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { styled } from 'styled-components';
import { layout, space } from 'styled-system';
export function Illustration(_a) {
    var _b, _c;
    var { name, alt = '', title, width, height, lazy = false, className = '' } = _a, props = __rest(_a, ["name", "alt", "title", "width", "height", "lazy", "className"]);
    // @ts-expect-error: env does not exist on type 'Window'
    const isTestEnv = (_c = (_b = window === null || window === void 0 ? void 0 : window.env) === null || _b === void 0 ? void 0 : _b.ASSETS) === null || _c === void 0 ? void 0 : _c.includes('assets-t');
    const imgUrl = `https://${isTestEnv ? 'assets-t' : 'assets'}.storebrand.no/illustrations/${name}.svg`;
    const combinedClassName = `illustration illustration-${name} ${className}`;
    return (React.createElement(IllustrationBase, Object.assign({ className: `
      ${combinedClassName}
      ${!height && 'autoHeight'}
      ` }, props),
        React.createElement("img", Object.assign({ src: imgUrl, alt: alt }, (title ? { title } : {}), { width: width !== null && width !== void 0 ? width : 'auto', height: height !== null && height !== void 0 ? height : 'auto', loading: lazy ? 'lazy' : 'eager', "aria-label": title }))));
}
export const IllustrationBase = styled.div `
  display: inline-flex;

  img {
    max-width: 100%;
    vertical-align: middle;
  }

  &.autoHeight img {
    height: auto;
  }

  ${space};
  ${layout};
`;
export default Illustration;
